import React from 'react';

import Loader from './Loader';

/** @type {React.FC} */
const LazyLoader = ({ children }) => (
  <React.Suspense fallback={<span data-cy="lazy-chunk-loading"><Loader /></span>}>
    {children}
  </React.Suspense>
);

export default LazyLoader;
